<div *ngIf="!showRequest">
	<h2 *ngIf="isShow" class="sectionTitle">{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.FORM_TITLE' | translate }}
	</h2>

	<div *ngIf="baseRequestId" class="read-only-content">
		<!-- request Details summary (reuse transit request summary) -->
		<app-transit-request #TransitRequest [IsAdminMode]="true"
			(FeesEstimateObjValue)="receiveFeesValue($event)"
			(latestStepId)="receiveLatestStepId($event)"></app-transit-request>
	</div>

	<div *ngIf="showModificationReason" class="bs-callout bs-callout-info">
		<h4>{{'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.MODIFICATION_REASON' | translate}}</h4>
		<p>{{ modificationReason }}</p>
	</div>

	<div *ngIf="baseRequestId">
		<form [formGroup]="guaranteeForm">
			<div class="form-container">
				<div class="form-section">

					<!-- Deduction Letter -->
					<div class="form-group">
						<label for="DeductionLetter">{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.DEDUCTION_LETTER' | translate}}
							<span class="red">*</span>
						</label>

						<!-- show existing uploaded file when in readonly/view mode -->
						<div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && deductionURL != ''">
							<!-- <label>{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.DEDUCTION_LETTER_File' | translate}}</label> -->
							<a id="uploaderDeductionURL" href="{{deductionURL}}" target="_blank">
								<i class="icon-view-file"></i>
								{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate }}
							</a>
						</div>
						<div *ngIf="formMode != FormMode.Readonly">
							<!-- Uploader -->
							<input *ngIf="!showDesclaimerMessage" type="file" formControlName="DeductionLetter" id="uploaderDeduction"
								class="form-control" name="uploaderDeduction" MaxSizeInMB="5"
								accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
								(change)="onDeductionFileSelected($event)" />

							<!-- Description About File [Size - Allowed EXT.] -->
							<div class="upload-info">
								<span data-toggle="tooltip"
									title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle'
									| translate}}</span>
								<span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
							</div>

							<!-- Progress Bar -->
							<div class="progress">
								<div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
									[style.width]="deductionProgress + '%'">
									<span class=""> {{deductionProgress}} % Complete</span>
								</div>
							</div>

							<!-- Required validate Message -->
							<div *ngIf="(submitted) || (f.DeductionLetter?.dirty && f.DeductionLetter?.invalid)" class="red">
								<div *ngIf="f.DeductionLetter?.errors?.required">
									{{'FRONT_USER.This_Field_Is_Required' | translate}}
								</div>
								<div *ngIf="f.DeductionLetter?.errors?.notCompleted">
									{{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
								</div>
							</div>
						</div>
					</div>

					<!-- Guarantee Letter -->
					<div class="form-group"
						*ngIf="formMode != FormMode.Readonly || guaranteeURL != ''">
						<label for="GuaranteeLetter">{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.GUARANTEE_LETTER' | translate
							}}</label>

						<!-- show existing uploaded file when in readonly/view mode -->
						<div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && guaranteeURL != ''">
							<!-- <label>{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.GUARANTEE_LETTER_File' | translate}}</label> -->
							<a id="uploaderGuaranteeURL" href="{{guaranteeURL}}" target="_blank">
								<i class="icon-view-file"></i>
								{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate }}
							</a>
						</div>
						<div *ngIf="formMode != FormMode.Readonly">
							<!-- Uploader -->
							<input *ngIf="!showDesclaimerMessage" type="file" formControlName="GuaranteeLetter" id="uploaderGuarantee"
								class="form-control" name="uploaderGuarantee" MaxSizeInMB="5"
								accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
								(change)="onGuaranteeFileSelected($event)" />

							<!-- Description About File [Size - Allowed EXT.] -->
							<div class="upload-info">
								<span data-toggle="tooltip"
									title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{
									'FRONT_USER.AllowedFileExtentionsTitle' | translate }}</span>
								<span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
							</div>

							<!-- Progress Bar -->
							<div class="progress">
								<div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
									[style.width]="guaranteeProgress + '%'">
									<span class=""> {{guaranteeProgress}} % Complete</span>
								</div>
							</div>

							<!-- Required validate Message -->
							<div *ngIf="(submitted) || (f.GuaranteeLetter?.dirty && f.GuaranteeLetter?.invalid)" class="red">
								<div *ngIf="f.GuaranteeLetter?.errors?.required">
									{{'FRONT_USER.This_Field_Is_Required' | translate}}
								</div>
								<div *ngIf="f.GuaranteeLetter?.errors?.notCompleted">
									{{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
								</div>
							</div>
						</div>
					</div>

					<!-- Additional Cheque -->
					<div class="form-group" *ngIf="formMode != FormMode.Readonly || additionalChequeURL != ''">
						<label for="AdditionalCheque">{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.ADDITIONAL_CHEQUE' | translate
							}}</label>

						<!-- show existing uploaded file when in readonly/view mode -->
						<div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && additionalChequeURL != ''">
							<!-- <label>{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.ADDITIONAL_CHEQUE_File' | translate}}</label> -->
							<a id="uploaderAdditionalChequeURL" href="{{additionalChequeURL}}" target="_blank">
								<i class="icon-view-file"></i>
								{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate }}
							</a>
						</div>
						<div *ngIf="formMode != FormMode.Readonly">
							<!-- Uploader -->
							<input *ngIf="!showDesclaimerMessage" type="file" formControlName="AdditionalCheque" id="uploaderAdditionalCheque"
								class="form-control"
								name="uploaderAdditionalCheque" MaxSizeInMB="5"
								accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
								(change)="onAdditionalChequeFileSelected($event)" />

							<!-- Description About File [Size - Allowed EXT.] -->
							<div class="upload-info">
								<span data-toggle="tooltip"
									title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{
									'FRONT_USER.AllowedFileExtentionsTitle' | translate }}</span>
								<span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
							</div>

							<!-- Progress Bar -->
							<div class="progress">
								<div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
									[style.width]="additionalChequeProgress + '%'">
									<span class=""> {{additionalChequeProgress}} % Complete</span>
								</div>
							</div>

							<!-- Required validate Message -->
							<div *ngIf="(submitted) || (f.AdditionalCheque?.dirty && f.AdditionalCheque?.invalid)" class="red">
								<div *ngIf="f.AdditionalCheque?.errors?.required">
									{{'FRONT_USER.This_Field_Is_Required' | translate}}
								</div>
								<div *ngIf="f.AdditionalCheque?.errors?.notCompleted">
									{{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="form-section">
					<!-- Penalties Commitment -->
					<label *ngIf="!showDesclaimerMessage"><span class="red">*</span>
						<input type="checkbox" id="CommitToPayPenalties" formControlName="CommitToPayPenalties" />
						{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.COMMIT_TO_PAY_PENALTIES' | translate }}
					</label>

					<!-- Validation message if not checked -->
					<div *ngIf="submitted && f.CommitToPayPenalties?.errors" class="red">
						<div *ngIf="f.CommitToPayPenalties?.errors?.required">
							{{ 'FRONT_USER.This_Field_Is_Required' | translate }}
						</div>
					</div>

					<!-- Confirmation message shown when checked -->
					<div *ngIf="f.CommitToPayPenalties?.value" class="alert alert-info mt-2" style="white-space: pre-line;">
						{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.COMMIT_TO_PAY_PENALTIES_MESSAGE' | translate }}
					</div>
				</div>

			</div>
			<!-- Disclaimer Message -->
			<div *ngIf="showDesclaimerMessage" class="alert alert-warning" role="alert">
				{{ 'FRONT_USER.TRANSIT.GUARANTEE_DEDUCTION_FORM.FEES_ESTIMATION_PENDING_MESSAGE' | translate }}
			</div>
			<div *ngIf="formMode != FormMode.Readonly && !showDesclaimerMessage" class="form-group">
				<button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
					'FRONT_USER.SUBMIT' | translate}}</button>
			</div>
		</form>
	</div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
	<div class="alignC">
		<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g>
				<g>
					<path
						d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
					</path>
				</g>
			</g>
		</svg>
		<p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
		<hr>
		<p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/myTasks">
				{{ 'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}</a></p>
	</div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
	<div class="alignC">
		<i class="icon-error"></i>

		<p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
		<hr>
		<p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/myTasks">
				{{ 'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}</a></p>
	</div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
	<div class="alignC">
		<i class="icon-error"></i>
		<p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
		<hr>
		<p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/myTasks">
				{{ 'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}</a></p>
	</div>
</div>